import React from 'react';
import { PrismicRichText } from '@prismicio/react';

/**
 * @typedef {import("@prismicio/client").Content.AccountPageBannerSlice} AccountPageBannerSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<AccountPageBannerSlice>} AccountPageBannerProps
 * @param { AccountPageBannerProps }
 */
const AccountPageBanner = ({ slice }) => {
  return null;
};

export default AccountPageBanner;
